const Loading = () => {
  return (
    <div className='flex items-center justify-center h-full w-full'><div className="loader"></div></div>
  )
}

export default Loading